(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('RecruiterSelectionDialogCtrl', RecruiterSelectionDialogCtrl);

    function RecruiterSelectionDialogCtrl(close, $timeout, dialogOptions, lodash) {
        const vm = this;
        vm.options = dialogOptions.options;
        vm.recruiter = dialogOptions.recruiter;
        vm.events = {
            toggleSelection: toggleSelection,
            selectionIsActive: selectionIsActive,
        };

        vm.selected_contacts = dialogOptions.selected_contacts || [];
        vm.is_selected = dialogOptions.is_selected;
        vm.dismiss = function () {
            close(false);
        };

        vm.confirm = function () {
            if (!!vm.recruiter.contacts && vm.recruiter.contacts.length > 0) {
                close({
                    selected_contacts: vm.selected_contacts
                });
            } else {
                close(true);
            }
        };

        function toggleSelection(contact) {
            var filtered = lodash.filter(vm.selected_contacts, function (_item) {
                return _item.select_id == contact.select_id;
            });
            if (filtered.length > 0) {
                vm.selected_contacts = lodash.filter(vm.selected_contacts, function (_item2) {
                    return _item2.select_id != contact.select_id;
                });
            } else {
                vm.selected_contacts.push(contact);
            }
        }

        function selectionIsActive(contact) {
            return lodash.filter(vm.selected_contacts, function (_item) {
                return _item.select_id == contact.select_id;
            }).length > 0;
        }

        $timeout(function () {
            vm.show = true;
        });
    }
})();